import React, { Component } from "react";
import rentContractDocumentStore from "../../store/rentContractDocuments.store";
import pdfSvg from "../../assets/svg/pdf.svg";
import icTmpPreview from "../../assets/ic-tmp-preview.png";
import icTmpDownload from "../../assets/ic-tmp-download.png";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import withRouter from "../../components/withRouter";
import { inject, observer } from "mobx-react";
import {
  extractError,
  extractErrorFromSap,
} from "../../service/response.service";
import LoadingPageOverlay from "../../components/LoadingPageOverlay";
import { extendObservable } from "mobx";
import NoContent from "../../components/NoContent";
import t from "../../service/translate.service";
import { ContractsImage } from "../../components/icons";
import { Alert } from "antd";
import moment from "moment";
import PropTypes from 'prop-types'
import ContractVerificationPage from "../Contracts/ContractVerificationPage";
import { appFeatureEnabled } from "../../service/appFeatures.service";
const dateContainer = {
  marginTop: 14
}

class RentContractDocuments extends Component {
  static propTypes = {
    contractStore: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props);
    extendObservable(this, {
      error: "",
      loading: false,
      verificationEnabled: false,
    });
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    (async () => {
      this.loading = true
      const verificationEnabled = appFeatureEnabled('verificationEnabled')
      try {
        if(verificationEnabled) {
          const { contractNumber } = this.props.useParams;
          const res = await this.props.contractStore.getContractVerificationInfo(
            contractNumber
          );
          if(!res) this.verificationEnabled = true
          const status = await this.props.contractStore.checkUserVerificationInfo()
          if(!status.email) {
            this.verificationEnabled = true
          } else await this.getDocuments();
        } else await this.getDocuments();
        this.loading = false
      } catch(err) {
        console.log('Error in rent contract documents:', err)
        this.loading = false
      }

    })();
  };

  downloadDocument = async (documentId, documentName) => {
    this.error = "";
    this.loading = true;
    try {
      const { contractNumber } = this.props.useParams;
      const file = await rentContractDocumentStore.getDocument(
        contractNumber,
        documentId,
        documentName
      );
      saveAs(file, documentName, {});
    } catch (err) {
      console.log(err)
      this.error =
        extractErrorFromSap(err) || t[extractError(err)] || t["ERROR"];
    }
    this.loading = false;
  };

  getDocuments = async () => {
    this.loading = true;
    this.error = "";
    try {
      const { contractNumber } = this.props.useParams;
      await rentContractDocumentStore.getDocuments(contractNumber);
    } catch (err) {
      this.error =
        extractErrorFromSap(err) || t[extractError(err)] || t["ERROR"];
    }
    this.loading = false;
  };

  render() {
    const { contractNumber } = this.props.useParams;
    const {
      role,
      partnerId,
      selectedContract
    } = this.props.contractStore;
    if (this.loading) {
      return <LoadingPageOverlay />;
    }
    if(this.verificationEnabled) {
      return <ContractVerificationPage isAddingContract={false} redirectUrl={`/rent-contract-documents/${contractNumber}`}/>
    }
    if (!appFeatureEnabled('pageRentContractDocumentsVisibleTo', [{ ...selectedContract, role }])) {
      this.props.navigate(
        `/contract-overview/${contractNumber}`
      );
      return null;
    }
    if (rentContractDocumentStore?.documents?.length > 0) {
      return (
        <div>
          {this.error && <Alert message={this.error} type="error" style={{ marginTop: "12px", marginBottom: "12px" }} aria-live="assertive" role='alert' />}
          <div className="documents-list" style={{ marginBottom: "30px" }}>
            {rentContractDocumentStore.documents.map((d) => {
              return (
                <div key={d.id} className="item">
                  <div className="container">
                    <div className="details">
                      <div className="svg">
                        <img src={pdfSvg} alt={t.PDF_ICON} />
                      </div>
                      <div>
                        <div className="group">
                          <div className="label" aria-label={`${t.DOCUMENT_NAME} ${d.name}`}>{d.name}</div>
                        </div>
                        <div className="group" style={dateContainer}>
                          <div className="label" aria-label={`${t.DOCUMENT_CREATED_ON} ${moment(d.createdOn).format('DD.MM.YYYY')}`}>
                            {moment(d.createdOn).format('DD.MM.YYYY')}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="actions">
                      <Link
                        className="open-preview"
                        to={`/rent-contract-documents/${this.props.useParams.contractNumber}/${d.id}/preview`}
                        aria-label={`${t.PREVIEW_DOCUMENT} ${d.name}`}
                      >
                        <img src={icTmpPreview} alt={`${t.PREVIEW_DOCUMENT} ${d.name}`} />
                      </Link>
                      <button
                        className="start-download"
                        onClick={() => this.downloadDocument(d.id, d.name)}
                        aria-label={`${t.DOWNLOAD_DOCUMENT} ${d.name}`}
                      >
                        <img src={icTmpDownload} alt={`${t.DOWNLOAD_DOCUMENT} ${d.name}`} />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {this.error && <Alert message={this.error} type="error" style={{ marginTop: "12px", marginBottom: "12px" }} aria-live="assertive" role='alert' />}
          <NoContent message={t.NO_RENT_CONTRACT_DOCUMENTS} image={ContractsImage} />
        </div>
      );
    }
  }
}

export default inject('contractStore')(withRouter(observer(RentContractDocuments)));
